import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const postTechType = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/addtechnologytype`,
    data,
  );
  return response.data;
};

const putTechDetails = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/UpdateCarePlanInformation`,
    data,
  );
  return response.data;
};

const fetchTechTypes = async () => {
  const response = await Axios.get(
    `${API_URL}/CarePlanWizardDetail/gettechnologytypes`,
  );
  return response.data;
};

const associateTechTypes = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/AssociateCarePlanTechnolgy`,
    data,
  );
  return response.data;
};

export { postTechType, putTechDetails, fetchTechTypes, associateTechTypes };
